import { useMemo } from 'react';

import { useQueries } from '@tanstack/react-query';

import type { Web3Handle } from '@shared/helpers/web3/handle';

import { getQueryKey } from '../config/query';
import { fetchFarmPoolsAPR } from './fetchFarmPoolsAPR';

const APR_REFETCH_INTERFAL = 30 * 1000;

export const useFarmPoolsAPR = (farmPoolHandles: Web3Handle[]) => {
  const queries = useQueries({
    queries: farmPoolHandles.map((farmPoolHandle) => ({
      queryKey: getQueryKey('magicFarmPoolAPR', farmPoolHandle.chainId, farmPoolHandle.address),
      queryFn: () => fetchFarmPoolsAPR(farmPoolHandle),
      enabled: Boolean(farmPoolHandle),
      refetchInterval: () => APR_REFETCH_INTERFAL,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    })),
  });

  return useMemo(() => {
    return queries.map((result) => result.data).filter(Boolean);
  }, [queries]);
};
